import React from "react";
import SectionSkills from "./Skills.styled";
import {Color} from "../Common/Colors";
import H2 from "../Common/H2.styled";
import Container from "../Common/Container.styled";
import StyledSkillsGrid from "./SkillsGrid.styled";
import StyledSkillsCard from "./SkillsCard.styled";
import IndustryKnowledgeList from "./IndustryKnowledgeList";
import ToolsList from "./ToolsList";
import SkillsFrameworkList from "./SkillsFrameworkList";

const Skills = () => {

    return (
        <SectionSkills id="skills" backgroundColor={Color.cultured}>
            <H2>Skills</H2>
            <Container>
                <StyledSkillsGrid>
                    <StyledSkillsCard>
                        <div className="skills_card-header">
                            <div className="skills_card-icon fa-solid fa-gears"/>
                            <h4 className="skills_card-title">Industry Knowledge</h4>
                        </div>
                        <div className="skills_card-body">
                            <IndustryKnowledgeList/>
                        </div>
                    </StyledSkillsCard>
                    <StyledSkillsCard>
                        <div className="skills_card-header">
                            <div className="skills_card-icon fa-solid fa-toolbox"/>
                            <h4 className="skills_card-title">Tools</h4>
                        </div>
                        <div className="skills_card-body">
                            <ToolsList/>
                        </div>
                    </StyledSkillsCard>
                    <StyledSkillsCard>
                        <div className="skills_card-header">
                            <div className="skills_card-icon fa-solid fa-screwdriver-wrench"/>
                            <h4 className="skills_card-title">Skills &amp; Frameworks</h4>
                        </div>
                        <div className="skills_card-body">
                            <SkillsFrameworkList/>
                        </div>
                    </StyledSkillsCard>
                </StyledSkillsGrid>
            </Container>
        </SectionSkills>
    );

}

export default Skills;